import styled from "styled-components/macro";

export const Container = styled.div`
  a.hotdog-dots {
    display: flex;
    align-items: center;
    .icon-wrapper {
      &:hover {
        background-color: var(--menu-color-hover);
      }
    }
    svg {
      circle {
        fill: var(--grey-1);
      }
    }
  }

  .custom-field-action-menu {
    position: absolute;
    right: 14px;
    top: 46px;
    z-index: 100;

    p {
      font-size: 14px;
      color: var(--grey-1);
      margin-left: 12px;
      margin-top: 18px;
      text-transform: uppercase;
    }

    &.visible {
      visibility: visible;
    }

    .custom-field-action-menu__inner {
      background-color: var(--menu-color);
      width: 100%;
      height: 100%;
      box-shadow: var(--default-drop-shadow);
      border-radius: 14px;

      .actions {
        padding: 4px;
        .delete {
          &:hover {
            background-color: var(--danger-color-hover);
          }
          &:active {
            background-color: var(--danger-color-active);
          }
        }
      }
    }

    .menu-item {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: center;
      padding: 10px 12px 10px 8px;
      border-radius: 10px !important;
      cursor: pointer;
      svg {
        path {
          fill: var(--grey-0) !important;
          stroke: none;
        }
      }
      &:hover {
        background-color: var(--menu-color-hover);
      }

      &:active {
        background-color: var(--menu-color-active);
      }

      &.selected {
        border: 2px solid var(--primary-cta) !important;
      }

      &.always {
        pointer-events: none;
        opacity: 0.5;
      }

      &.delete {
        .label {
          color: var(--danger-color);
        }
        svg {
          max-height: 24px !important;
          path {
            fill: var(--danger-color) !important;
            stroke: none;
          }
        }
      }

      &:first-child {
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
      }

      &:last-child {
        border-bottom-left-radius: 20px;
        border-bottom-right-radius: 20px;
      }
    }

    .label {
      font-size: 16px;
      white-space: nowrap;
      color: var(--grey-0);
      font-weight: 500;
    }

    .description {
      color: var(--grey-1);
      font-size: 14px;
    }

    .icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 20px;
      height: 20px;
      margin-right: 5px;

      svg {
        max-height: 24px !important;
        path {
          fill: var(--grey-0);
          stroke: none;
        }
      }
    }
  }

  .delete-message-container {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    gap: 15px;
    padding: 20px;
    width: 200px;
    font-size: 16px;
    line-height: 1.3;
    color: var(--grey-0);
    font-weight: 500;
    background-color: var(--menu-color);
    border-radius: 15px;

    .delete-heading {
      font-weight: bold;
    }

    .delete-message {
      span {
        font-style: italic;
      }
    }

    .confirm {
      color: var(--danger-color);
      font-weight: 500;
      cursor: pointer;
      padding: 12px 8px;
      margin-left: -6px;
      transition: background-color 200ms;
      border-radius: 10px;
      width: fit-content;
      &:hover {
        background-color: var(--menu-color-hover);
      }
      &:active {
        background-color: var(--menu-color-active);
      }
    }
  }
`;
